import EntityPresenter, { bindPresenterMethods } from './entityPresenter'
import { fetcherPost } from './fetcher'

export default class UserPresenter extends EntityPresenter {
  static urn = 'users'
  static key = 'user'

  static async upsert(body) {
    return await this.post(`with-profile`, body)
  }

  static navOptions(key = 'users') {
    const routes = {
      users: {
        icon: 'group',
        pageRoutes: ['user'],
      }
    }
    return routes[key]
  }
}

bindPresenterMethods(UserPresenter)
